
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    TabContent,
    TabPane,
    NavItem,
    NavLink,
    Button,
    Badge,
    Table,
    Media,
    Input,
    Label,
    Form,
} from "reactstrap"
import classnames from "classnames"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

// Actions
import { setBreadcrumbItems, getCustomerDetail } from "../../store/actions"
import { getInteractions, addNewInteraction, getDocuments, addNewDocument, deleteDocument } from "../../helpers/fakebackend_helper"

const CustomerDetail = props => {
    const [activeTab, setActiveTab] = useState("1")
    const { customer } = props
    const [interactions, setInteractions] = useState([])
    const [documents, setDocuments] = useState([])
    const [newNote, setNewNote] = useState("")
    const [noteType, setNoteType] = useState("note")

    const customerId = props.router.params.id

    useEffect(() => {
        props.getCustomerDetail(customerId)
        fetchInteractions()
        fetchDocuments()

        props.setBreadcrumbItems("Détails Client", [
            { title: "CRM", link: "#" },
            { title: "Clients", link: "/clients" },
            { title: "Profil", link: "#" },
        ])
    }, [customerId])

    const fetchInteractions = async () => {
        const res = await getInteractions(customerId)
        setInteractions(res)
    }

    const fetchDocuments = async () => {
        const res = await getDocuments(customerId, 'App\\Models\\Customer')
        setDocuments(res)
    }

    const handleAddInteraction = async (e) => {
        e.preventDefault()
        if (!newNote) return
        await addNewInteraction({
            customer_id: customerId,
            type: noteType,
            content: newNote,
            interaction_date: new Date().toISOString(),
        })
        setNewNote("")
        fetchInteractions()
    }

    const handleFileUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        await addNewDocument({
            file: file,
            documentable_id: customerId,
            documentable_type: 'App\\Models\\Customer',
        })
        fetchDocuments()
    }

    const handleDeleteDoc = async (id) => {
        if (window.confirm("Supprimer ce document ?")) {
            await deleteDocument(id)
            fetchDocuments()
        }
    }

    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab)
    }

    if (!customer) {
        return <div className="p-5 text-center">Chargement...</div>
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg="4">
                    <Card>
                        <CardBody>
                            <div className="text-center mb-4">
                                <div className="avatar-lg mx-auto mb-4">
                                    <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-24">
                                        <i className="mdi mdi-account"></i>
                                    </span>
                                </div>
                                <h5 className="font-size-16">{customer.first_name} {customer.last_name}</h5>
                                <p className="text-muted">{customer.company_name || 'Particulier'}</p>
                                <Badge color={customer.status === 'customer' ? 'success' : 'warning'} className="font-size-12">
                                    {customer.status === 'customer' ? 'Client Actif' : customer.status}
                                </Badge>
                            </div>

                            <hr className="my-4" />

                            <div className="table-responsive">
                                <Table className="table-nowrap mb-0" borderless>
                                    <tbody>
                                        <tr>
                                            <th scope="row">N° Client :</th>
                                            <td>{customer.customer_number}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Email :</th>
                                            <td>{customer.email}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Téléphone :</th>
                                            <td>{customer.phone || '-'}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Ville :</th>
                                            <td>{customer.city || '-'}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Adresse :</th>
                                            <td className="text-wrap">{customer.address || '-'}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col lg="8">
                    <Card>
                        <CardBody>
                            <NavItem className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                                <NavLink
                                    className={classnames({ active: activeTab === "1" })}
                                    onClick={() => toggleTab("1")}
                                >
                                    <span className="d-none d-sm-block">Interactions</span>
                                </NavLink>
                                <NavLink
                                    className={classnames({ active: activeTab === "2" })}
                                    onClick={() => toggleTab("2")}
                                >
                                    <span className="d-none d-sm-block">Documents</span>
                                </NavLink>
                            </NavItem>

                            <TabContent activeTab={activeTab} className="p-3">
                                <TabPane tabId="1">
                                    <Form className="mb-4" onSubmit={handleAddInteraction}>
                                        <Row className="mb-3">
                                            <Col sm="3">
                                                <Input type="select" value={noteType} onChange={(e) => setNoteType(e.target.value)}>
                                                    <option value="note">Note interne</option>
                                                    <option value="call">Appel</option>
                                                    <option value="email">Email</option>
                                                    <option value="meeting">Réunion</option>
                                                </Input>
                                            </Col>
                                            <Col sm="7">
                                                <Input
                                                    type="textarea"
                                                    placeholder="Écrire une note..."
                                                    rows="1"
                                                    value={newNote}
                                                    onChange={(e) => setNewNote(e.target.value)}
                                                />
                                            </Col>
                                            <Col sm="2">
                                                <Button color="primary" block type="submit">Enregistrer</Button>
                                            </Col>
                                        </Row>
                                    </Form>

                                    <div className="timeline-list">
                                        {interactions.length === 0 && <p className="text-center text-muted">Aunuce interaction enregistrée.</p>}
                                        {interactions.map((item, key) => (
                                            <div key={key} className="d-flex mb-4">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-xs">
                                                        <span className={`avatar-title rounded-circle bg-soft-${item.type === 'call' ? 'primary' : 'info'} text-${item.type === 'call' ? 'primary' : 'info'}`}>
                                                            <i className={`mdi ${item.type === 'call' ? 'mdi-phone' : (item.type === 'email' ? 'mdi-email' : (item.type === 'meeting' ? 'mdi-calendar-check' : 'mdi-note-text'))}`}></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 border-bottom pb-3">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <h5 className="font-size-14 mb-1">{item.type.toUpperCase()}</h5>
                                                        <p className="font-size-12 text-muted mb-0">
                                                            {new Date(item.interaction_date).toLocaleString()}
                                                        </p>
                                                    </div>
                                                    <p className="text-muted mb-0">{item.content}</p>
                                                    <small className="text-primary">Par : {item.user?.first_name} {item.user?.last_name}</small>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </TabPane>

                                <TabPane tabId="2">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="font-size-14 mb-0">Documents joints</h5>
                                        <div className="position-relative">
                                            <Button color="success" size="sm">
                                                <i className="mdi mdi-upload me-1"></i> Ajouter
                                            </Button>
                                            <input
                                                type="file"
                                                className="position-absolute top-0 start-0 opacity-0 w-100 h-100 cursor-pointer"
                                                onChange={handleFileUpload}
                                            />
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <Table className="table-centered table-nowrap mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Nom</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                    <th>Taille</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.length === 0 && <tr><td colSpan="5" className="text-center text-muted">Aucun document.</td></tr>}
                                                {documents.map((doc, key) => (
                                                    <tr key={key}>
                                                        <td>{doc.name}</td>
                                                        <td><Badge color="info">{doc.file_type.toUpperCase()}</Badge></td>
                                                        <td>{new Date(doc.created_at).toLocaleDateString()}</td>
                                                        <td>{(doc.file_size / 1024).toFixed(2)} KB</td>
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                <a href={`${process.env.REACT_APP_STORAGE_URL}/${doc.file_path}`} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">
                                                                    <i className="mdi mdi-download"></i>
                                                                </a>
                                                                <Button color="danger" size="sm" onClick={() => handleDeleteDoc(doc.id)}>
                                                                    <i className="mdi mdi-trash-can"></i>
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    customer: state.Customers.customer,
})

export default withRouter(connect(mapStateToProps, { setBreadcrumbItems, getCustomerDetail })(CustomerDetail))
